// Механизм работы с корзиной и заказами

$(function() {

    const setCounterState = (count) => {
        const value = parseInt(count);
        if (!isNaN(value)) {
            $('.js-basket-counter').each(function() {
                if (value > 0) {
                    $(this).removeClass('d-none');
                } else {
                    $(this).addClass('d-none');
                }
                $(this).html(value > 0 ? (value > 99 ? '99+' : value) : '');
            })
        }
    }

    const handleErrorResponse = (xhr) => {
        const commonAlert$ = $('#js-common-alert');
        const defaultErrorTxt = commonAlert$.data('error-text');
        if (commonAlert$.length) {
            $(commonAlert$).html(xhr.status === 422 ? xhr.responseText : defaultErrorTxt);
            $(commonAlert$).removeClass('d-none');
            $(commonAlert$).addClass('alert-danger');
        } else {
            alert(xhr.responseText);
        }
    }

    function inc_dec(event, element, link, params) {
        event.preventDefault();
        const product_id = element.parent().data('product');

        if (!params) {
            params = {};
        }

        if (product_id) {
            $.ajax(link, {
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({'product_id': product_id, ...params})
            }).done(data => {
                location.reload();
            }).fail(function(xhr) {
                handleErrorResponse(xhr);
            });
        }
    }

    $('.js-buy-button').on('click', function(e) {
        e.preventDefault()

        const product_id = $(this).data('product');
        const category_id = $(this).data('category');
        const iconBtn = $(this).data('icon');
        const text = $(this).text();

        if (product_id && category_id) {
            $(this).prop('disabled', true);
            if (!iconBtn) {
                $(this).html('<div class="spinner-border spinner-border-sm mr-2" role="status"></div> ' + text);
            }
            $.ajax('/shop/ajax/buy', {
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({ 'category_id': category_id, 'product_id': product_id })
            }).done(data => {
                setCounterState(data);
                $(this).prop('disabled', false);
                if (!iconBtn) {
                    $(this).html(text);
                }
            }).fail(function(xhr) {
                handleErrorResponse(xhr);
                $(this).prop('disabled', false);
                if (!iconBtn) {
                    $(this).html(text);
                }
            });
        }
    });

    $('.js-empty-basket').on('click', function(e) {
        e.preventDefault();
        $.ajax('/shop/ajax/empty', {
            method: 'POST',
            contentType: 'application/json',
            data: {}
        }).done(data => {
            location.reload()
        }).fail(function(xhr) {
            handleErrorResponse(xhr);
        });
    });

    $('.js-remove-from-basket').on('click', function(e) {
        e.preventDefault();

        const product_id = $(this).data('product');
        if (product_id) {
            $.ajax('/shop/ajax/remove', {
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({ 'product_id': product_id })
            }).done(data => {
                location.reload()
            }).fail(function(xhr) {
                handleErrorResponse(xhr);
            });
        }
    });

    // Увеличение / уменьшение кол-ва товара в корзине
    $('.js-inc-quantity').on('click', function(e) {
        inc_dec(e, $(this), '/shop/ajax/inc');
    });
    $('.js-dec-quantity').on('click', function(e) {
        inc_dec(e, $(this), '/shop/ajax/dec');
    });
    $('.js-quantity-input').on('change', function(e) {
        let val = parseInt($(this).val());
        if (val > 0 && val < 100) {
            let p = {'quantity': val}
            inc_dec(e, $(this), '/shop/ajax/qty', p);
        }
    });

    // Интеграция с Shiptor

    let shiptorWidget = document.querySelector('#shiptor_widget_delivery');
    if (shiptorWidget) {
        shiptorWidget.addEventListener('onWidgetSuccess', function (ce) {
            console.log(ce.detail);
            $.ajax('/shop/ajax/delivery', {
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(ce.detail)
            }).done(data => {
                location.reload();
            }).fail(function (xhr) {
                alert('Произошла ошибка'); // TODO: replace with handleErrorResponse
            })
        });
    }

    $('#address').on('change', function() {
        $(this).closest('form').trigger('submit');
    });

    function applyPromo(elem, event) {
        $.ajax('/shop/ajax/promo', {
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({'code': elem.val()})
        }).done(data => {
            location.reload();
        }).fail(function(xhr) {
            handleErrorResponse(xhr);
        });
    }

    let promoInput = $('#shop-input-promo');
    if (promoInput) {
        // promoInput.on('change', function(e) { applyPromo($(this), e)})
        promoInput.on('keyup', function(e) {
            if (e.key === 'Enter') {
                applyPromo($(this), e);
            }
        });
    }
    let promoSubmitBtn = $('#shop-submit-promo');
    if (promoInput) {
        promoSubmitBtn.on('click', function(e) {
            e.preventDefault();
            applyPromo($(promoInput), e);
        });
    }
    let cancelPromoEl = $('#shop-cancel-promo');
    if (cancelPromoEl) {
        cancelPromoEl.on('click', function(e) {
            e.preventDefault();
            $.ajax('/shop/ajax/promocancel', {
                method: 'POST',
                contentType: 'application/json',
                data: {}
            }).done(data => {
                location.reload();
            }).fail(function(xhr) {
                handleErrorResponse(xhr);
            });
        });
    }

    // yookassa widget
    let payment_widget = $("#payment-form");
    if (payment_widget.length > 0) {
        let checkout = new window.YooMoneyCheckoutWidget({
            confirmation_token: payment_widget.data('token'),
            return_url: payment_widget.data('return_url'),
            error_callback: function (xhr) {
                handleErrorResponse(xhr);
            }
        });
        checkout.render('payment-form');
    }
})
